export class ParagraphConstraints {
  width?: number;
  constructor(props: {width: number}) {
    this.width = props.width;
  }
}
